import classNames from 'classnames'
import Button from '@components/Button'
import Icon from '@components/Icon'
import ServiceIcons from '@components/ServiceIcons'
import StartFromPrice from 'shared/components/StartFromPrice'
import styles from './styles.module.scss'

const ResultsListItem = ({
    onMouseEnter,
    onMouseLeave,
    onClick,
    name,
    carParkUrl,
    offline,
    active,
    children,
    services,
    renderOperator,
    translate: t,
}) => {
    const itemHasAtLeastOneIcon = Object.values(services).some(service => service)
    const { canBuy, rate, opngo, bookingUrl } = children?.props || {}

    return (
        <div
            itemScope
            itemType="http://schema.org/Park"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            className={classNames(styles.result, {
                [styles.offline]: offline,
                [styles.active]: active,
            })}>
            <div className={styles.params}>
                <Button btnStyle="link" href={carParkUrl} external iconRight="info">
                    <b>{name.toUpperCase()}</b>
                </Button>

                {/* checking an item(service) has at least one value = true or if everything is false then no icons should be displayed.  */}
                <div className={styles.resultContent}>
                    {itemHasAtLeastOneIcon && (
                        <span className={classNames('d-flex', 'justify-content-start', styles.services)}>
                            <ServiceIcons
                                services={services}
                                render={({ type, index, title }) => (
                                    <span key={index} title={t ? t(title) : ''} className="mr-4">
                                        <Icon type={type} size="xs" className={styles.icon} />
                                    </span>
                                )}
                            />

                            {renderOperator && <span className={styles.operator}>{renderOperator()}</span>}
                        </span>
                    )}
                    {rate && !canBuy && (
                        <StartFromPrice
                            rate={rate}
                            textRowsDirection="flex-column"
                            linkUrl={bookingUrl}
                            opngo={opngo}
                            canBuy={canBuy}
                            isLabelTextBold
                            width="w-100"
                            displayPosition="align-items-end"
                            showAdditionalText
                        />
                    )}
                </div>
                <div className="w-100 mt-3">{children}</div>
            </div>
        </div>
    )
}

export default ResultsListItem
